import { labelAuthor, labelISBN, labelTopic } from "_constants";
import { Source } from "interfaces";
import { Tooltip } from "primereact/tooltip";
import { useAppSelector } from "store/store";

export const SourceDetailPanelBodyTopicContainer = () => {
  const currentSource = useAppSelector(
    (state) => state.gestioneSourcesSlice.currentSource
  ) as Source | null;

  return (
    <div
      className={`source-info-container ${
        !currentSource?.author?.length && !currentSource?.isbn?.length
          ? "only-topic"
          : ""
      }`}
    >
      <div className="flex-container column gap-8">
        <span className="text-base-regular-bold">
          {labelTopic.toUpperCase()}
        </span>
        <>
          <Tooltip target={`.topic-name`} mouseTrack mouseTrackLeft={10} />

          <span
            className={`topic-name clamp-1 topic-chip`}
            data-pr-tooltip={currentSource?.topic}
          >
            {currentSource?.topic}
          </span>
        </>
      </div>
      {(currentSource?.author || currentSource?.isbn) && (
        <div className="flex-container">
          {currentSource?.author && (
            <>
              <div className="flex-container column gap-8 width-246">
                <span className="text-base-regular-bold">
                  {labelAuthor.toUpperCase()}
                </span>
                <>
                  <Tooltip
                    target={`.topic-name`}
                    mouseTrack
                    mouseTrackLeft={10}
                  />

                  <span
                    data-pr-tooltip={currentSource?.author}
                    className="capitalize clamp-1"
                  >
                    {currentSource?.author}
                  </span>
                </>
              </div>
              {currentSource?.isbn && (
                <div className="vertical-separator"></div>
              )}
            </>
          )}
          {currentSource?.isbn && (
            <div className="flex-container column gap-8">
              <span className="text-base-regular-bold">
                {labelISBN.toUpperCase()}
              </span>
              <>
                <span data-pr-tooltip={currentSource?.isbn}>
                  {currentSource?.isbn}
                </span>
              </>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
